import domReady from '@wordpress/dom-ready';
import { render, useState, useRef, useEffect } from '@wordpress/element';
import { nanoid } from 'nanoid';
import dokanSpreadMap from './assets/img/dokan-spread-map.png';
import australia from './assets/img/australia.png';
import austria from './assets/img/austria.png';
import brazil from './assets/img/brazil.png';
import canada from './assets/img/canada.png';
import china from './assets/img/china.png';
import ecuador from './assets/img/ecuador.png';
import france from './assets/img/france.png';
import germany from './assets/img/germany.png';
import india from './assets/img/india.png';
import iran from './assets/img/iran.png';
import ireland from './assets/img/ireland.png';
import japan from './assets/img/japan.png';
import malaysia from './assets/img/malaysia.png';
import russia from './assets/img/russia.png';
import southAfrica from './assets/img/southAfrica.png';
import southKorea from './assets/img/southKorea.png';
import saudiArabia from './assets/img/saudiArabia.png';
import uk from './assets/img/uk.png';
import us from './assets/img/us.png';
import { imageMapArea } from './data';

const flags = {
	australia,
	austria,
	brazil,
	canada,
	china,
	ecuador,
	france,
	germany,
	india,
	iran,
	ireland,
	japan,
	malaysia,
	russia,
	southAfrica,
	southKorea,
	saudiArabia,
	uk,
	us,
};

const activeItem = {
	activeIndex: 0,
	heading:
		'<span style="font-weight: 800; color: #636161; display: block;">27,363+ </span>  Marketplaces in <span style="font-weight: 800; color: #636161;">USA</span>',
	content:
		'Based in <span style="font-weight: 800; color: #636161;">California.</span>, <span style="color: #00aeff;">Bootstrap</span>, a popular front-end-framework uses Dokan for their Multi Vendor Theme Marketplace.',

	flag: 'us',
	link: '',
};

const App = () => {
	const areaTooltip = useRef( null );
	const spreadMap = useRef( null );
	const doBlocksMapWrap = useRef( null );
	const [ imageMap, setImageMap ] = useState( activeItem );

	const handleLocation = ( e, i, area ) => {
		const toolTip = areaTooltip.current;
		const toolTipHeight = toolTip.clientHeight + 20;
		const coords = area.coords.split( ',' );
		const coordLeft = parseInt( coords[ 0 ] ) - 20;
		const coordTop = parseInt( coords[ 1 ] );

		toolTip.style.left = `${ coordLeft }px`;
		toolTip.style.top = parseInt( coordTop - toolTipHeight ) + 'px';

		setImageMap( {
			activeIndex: i,
			heading: area.heading,
			content: area.content,
			flag: area.flag,
			link: area.link,
		} );
	};

	useEffect( () => {
		const areas = spreadMap.current.areas;

		let index = 1;
		let intervalId;

		function callbackFunc( entries ) {
			if ( entries[ 0 ].isIntersecting ) {
				intervalId = setInterval( () => {
					areas[ index ].click();
					index++;
					index %= areas.length;
				}, 2000 );

				// const areasArr = Array.from( areas );

				// areasArr.forEach( ( ele, i ) => {
				// 	ele.addEventListener( 'mouseover', () => {
				// 		clearInterval( intervalId );
				// 		index = i;
				// 	} );
				// } );
			} else {
				clearInterval( intervalId );
			}
		}

		// eslint-disable-next-line no-undef
		const observer = new IntersectionObserver( callbackFunc, {
			threshold: 0.4,
		} );

		observer.observe( doBlocksMapWrap.current );

		return () => {
			clearInterval( intervalId );
		};
	}, [] );

	return (
		<div ref={ doBlocksMapWrap }>
			<div className="dokan-spread-map">
				<img
					src={ dokanSpreadMap }
					width="1265"
					alt="dokan spread map"
					useMap="#spreadmap"
				/>

				<map name="spreadmap" ref={ spreadMap }>
					{ imageMapArea.map( ( area, index ) => (
						// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/mouse-events-have-key-events
						<area
							className={ area.title.toLowerCase() }
							key={ nanoid() }
							title={ area.title }
							coords={ area.coords }
							shape="rect"
							alt={ area.title }
							onClick={ ( e ) =>
								handleLocation( e, index, area )
							}
							onMouseOver={ ( e ) =>
								handleLocation( e, index, area )
							}
						/>
					) ) }
				</map>

				<div
					className={ `area-tooltip area-tooltip-${ imageMap.activeIndex }` }
					ref={ areaTooltip }
				>
					<div className="area-tooltip-header">
						<img
							src={ flags[ imageMap.flag ] }
							width="36"
							alt="flag"
							loading="lazy"
						/>
						<p
							dangerouslySetInnerHTML={ {
								__html: imageMap.heading,
							} }
						></p>
					</div>
					<div className="area-tooltip-body">
						<p
							dangerouslySetInnerHTML={ {
								__html: imageMap.content,
							} }
						></p>
						{ imageMap.link && (
							<a href={ imageMap.link }>Read more</a>
						) }
					</div>
				</div>
			</div>
		</div>
	);
};

domReady( () => {
	const mountWrap = document.getElementById( 'dokan-speared-worldwide-map' );
	const attributes = mountWrap.getAttribute( 'gutenberg-data-attributes' );

	render( <App attributes={ JSON.parse( attributes ) } />, mountWrap );
} );
